/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react';
import { Media } from 'components/templates/media';
import { LANGUAGE_OPTIONS, MEDIA_OPTION_LIST, NEWS_LIST } from 'libs/constants';
import { withRouter, NextRouter } from 'next/router';
import { NextSeo } from 'next-seo';

interface MediaPageProps {
  router: NextRouter;
  lang: string;
  option: string;
}

const MediaPage: React.FC<MediaPageProps> = ({ router, lang, option }) => {
  // const router = useRouter();
  const optionList = MEDIA_OPTION_LIST as any;
  let currentTab = 0;
  let currentOptionName = '';

  if (optionList.map((x: any) => x.value).includes(option)) {
    optionList.forEach((item: any, index: number) => {
      if (item.value === option) {
        currentOptionName = item.label;
        currentTab = index;
      }
    });
  } else {
    // redirect back to root
    router.push(`/${lang}/media`);
  }

  const handleOptionSelected = useCallback(
    (tab: number) => {
      if (optionList[tab]) {
        const optionItem = optionList[tab] as any;
        router.push(`/${lang}${optionItem.link}`, undefined, {
          scroll: false,
        });
      }
    },
    [lang, optionList, router]
  );

  const handleNewsClick = useCallback(
    (slug: string) => {
      const news = NEWS_LIST.filter((x: any) => x.slug === slug).pop();
      if (news) {
        router.push(`/${lang}/media/news/${slug}`, undefined, {
          scroll: true,
        });
      }
    },
    [router, lang]
  );

  return (
    <>
      <NextSeo title={'媒体 - ' + currentOptionName[lang as any]} />
      <Media onOptionSelected={handleOptionSelected} onNewsClick={handleNewsClick} currentTab={currentTab} />
    </>
  );
};

export default withRouter(MediaPage);

export async function getStaticPaths() {
  // generate path for static generation
  const options: any = MEDIA_OPTION_LIST.map((x: any) => x.value);

  const paths: any = [];
  LANGUAGE_OPTIONS.forEach((item: any) => {
    options.forEach((option: string) => {
      paths.push({
        params: {
          lang: item.value,
          option,
        },
      });
    });
  });
  return { paths, fallback: false };
}

export async function getStaticProps(args: any) {
  const { lang, option } = args.params;

  return {
    props: {
      lang,
      option,
    },
  };
}
